import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  TimePeriod,
} from "app/shared";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { AppLanguageConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
    selector: 'app-language-details',
    templateUrl: './app-language-details.component.html',
    standalone: false
})
export class AppLanguageDetailsComponent
  extends BaseDetailsLogic<AppLanguageConfig>
  implements OnInit, OnDestroy
{

  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(analyticsService, authService, loggingService, AppLanguageConfig, tooltipCoordinator);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      language: "Shows the distribution of application languages being used by your users. This helps you understand which languages are most popular and may inform localization decisions."
    };
  }
}
